import { init } from 'smolcart.js';

export const updateCartCount = async () => {
  const cart = init();
  const cartData = await cart.getCart();
  const cartCountEl = document.querySelector('#CartCount');
  const cartCountSpan = cartCountEl.querySelector('[data-cart-count]');
  if (cartData.item_count > 0) {
    cartCountEl.classList.remove('hide');
    console.log(cartCountSpan);
    cartCountSpan.innerText = cartData.item_count;
  } else {
    cartCountEl.classList.add('hide');
    cartCountSpan.innerText = 0;
  }
};
